// Translation JSON map for aspire-ui.components.Constants.DetailedFeedbackText.js

import React from 'react'
import { FormattedMessage } from 'react-intl'
export const sectionUnderscoreName = {
  Education: 'education',
  Experience: 'experience',
  Headline: 'headline',
  'Personal Information': 'personal_information',
  'Profile Picture': 'profile_picture',
  Summary: 'summary',
}

export const sectioNameToBackendVisitedSectioNameMapping = {
  'Personal Information': 'detailed_personal_info',
  'Profile Picture': 'detailed_profile_picture',
  Headline: 'detailed_headline',
  Summary: 'detailed_summary',
  Experience: 'detailed_experience',
  Education: 'detailed_education',
  'Summary Screen': 'summary',
  'Edit Personal Information': 'edit_personal_info',
  'Edit Profile Picture': 'edit_profile_picture',
  'Edit Headline': 'edit_headline',
  'Edit Summary': 'edit_summary',
  'Edit Experience': 'edit_experience',
  'Edit Education': 'edit_education',
}

export const staticFeedback = (intl) => ({
  'Personal Information': null,
  'Profile Picture': null,
  Headline: {
    about: [
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.headlineAboutTitle',
        defaultMessage: 'ABOUT THE HEADLINE',
      }),
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.headlineAboutDescription',
        defaultMessage:
          'A 220 character hook to stand out from your competitors and entice the visitors to click on your profile.',
      }),
    ],
  },
  Summary: {
    about: [
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.summaryAboutTitle',
        defaultMessage: 'ABOUT THE ABOUT SECTION',
      }),
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.summaryAboutDescription',
        defaultMessage:
          'Use your about section to spell out to your network or visitors - who YOU are and what you are looking to accomplish.',
      }),
    ],
  },
  Experience: {
    about: [
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.experienceAboutTitle',
        defaultMessage: 'ABOUT THE EXPERIENCE SECTION',
      }),
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.experienceAboutDescription',
        defaultMessage:
          'The objective of the experience section is to showcase your past and present positions and give the viewer a gist of your career track.',
      }),
    ],
  },
  Education: {
    about: [
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.educationAboutTitle',
        defaultMessage: 'ABOUT THE EDUCATION SECTION',
      }),
      intl.formatMessage({
        id: 'aspire.detailedFeedbackText.staticFeedback.educationAboutDescription',
        defaultMessage:
          'Use this section to tell the visitors about your educational background, positions of responsibility that you held and other extracurricular activities that you participated in.',
      }),
    ],
  },
})


export const feedbackMap = (intl, isUKEnable) => ({
  face_frame_ratio: {
    key: '1',
    green: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceFrameRatio.green',
      defaultMessage: 'You have done a good job keeping your face/frame ratio of around 50%.',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceFrameRatio.yellow',
      defaultMessage: 'Try to maintain a face/frame ratio of around 50%.',
    }),
    red: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceFrameRatio.red',
      defaultMessage: 'Try to maintain a face/frame ratio of around 50%.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceFrameRatio.gray',
      defaultMessage: 'Feature cannot be detected. A good image has a face/frame ratio of around 50%.',
    }),
  },
  background: {
    key: '2',
    green: intl.formatMessage(
      {
        id: 'aspire.detailedFeedbackText.feedbackMap.background.green',
        defaultMessage: 'Your profile picture has a light {colorType, select, uk {coloured} other {colored}} background. Good job!',
      },
      { colorType: isUKEnable ? 'uk' : 'other' }
    ),
    yellow: intl.formatMessage(
      {
        id: 'aspire.detailedFeedbackText.feedbackMap.background.yellow',
        defaultMessage: 'Make sure your picture has a light {colorType, select, uk {coloured} other {colored}} background.',
      },
      { colorType: isUKEnable ? 'uk' : 'other' }
    ),
    red: intl.formatMessage(
      {
        id: 'aspire.detailedFeedbackText.feedbackMap.background.red',
        defaultMessage: 'Make sure your picture has a light {colorType, select, uk {coloured} other {colored}} background.',
      },
      { colorType: isUKEnable ? 'uk' : 'other' }
    ),
    gray: intl.formatMessage(
      {
        id: 'aspire.detailedFeedbackText.feedbackMap.background.gray',
        defaultMessage: 'Feature cannot be detected. A good image should have a light {colorType, select, uk {coloured} other {colored}} background for clearer picture portrayal.',
      },
      { colorType: isUKEnable ? 'uk' : 'other' }
    ),
  },
  foreground: {
    key: '3',
    green: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.foreground.green',
      defaultMessage: 'There are no shadows or reflections interfering with the clarity and prominence of your face. Good job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.foreground.yellow',
      defaultMessage: 'Ensure that shadows or reflections do not interfere with the clarity and prominence of your face.',
    }),
    red: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.foreground.red',
      defaultMessage: 'Ensure that shadows or reflections do not interfere with the clarity and prominence of your face.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.foreground.gray',
      defaultMessage: 'Feature cannot be detected. A good picture is free of any shadow or object reflection.',
    }),
  },
  resolution: {
    key: '4',
    green: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.resolution.green',
      defaultMessage: 'Your photo size is within the specified limits of 400 x 400 and 20K x 20K pixels. Good job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.resolution.yellow',
      defaultMessage: 'Ensure that your photo size is within the specified limits of 400 x 400 and 20K x 20K pixels.',
    }),
    red: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.resolution.red',
      defaultMessage: 'Ensure that your photo size is within the specified limits of 400 x 400 and 20K x 20K pixels.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.resolution.gray',
      defaultMessage: 'Feature cannot be detected. Photo size should be within 400 x 400 and 20K x 20K pixels for optimum picture clarity.',
    }),
  },
  face_body_ratio: {
    key: '5',
    green: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceBodyRatio.green',
      defaultMessage: 'Your profile picture has an appropriate face to body ratio. Good Job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceBodyRatio.yellow',
      defaultMessage: 'Ensure that your face covers a larger area in the picture as compared to your body.',
    }),
    red: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceBodyRatio.red',
      defaultMessage: 'Ensure that your face covers a larger area in the picture as compared to your body.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.faceBodyRatio.gray',
      defaultMessage: 'Feature cannot be detected. In a good profile picture, your face covers a larger area as compared to your body.',
    }),
  },
  pupil: {
    key: '6',
    green: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.pupil.green',
      defaultMessage: 'You have done a good job of maintaining eye contact with the camera.',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.pupil.yellow',
      defaultMessage: 'Ensure that your profile picture has a clear depiction of your eye contact with the camera.',
    }),
    red: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.pupil.red',
      defaultMessage: 'Ensure that your profile picture has a clear depiction of your eye contact with the camera.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.pupil.gray',
      defaultMessage: 'Feature cannot be detected. One should maintain eye contact with the camera as it signifies self confidence.',
    }),
  },
  smile: {
    key: '7',
    green: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.smile.green',
      defaultMessage: 'An open smile increases likeability. Good Job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.smile.yellow',
      defaultMessage: 'Please try uploading a picture with a wide, open smile as it increases likeability.',
    }),
    red: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.smile.red',
      defaultMessage: 'Please try uploading a picture with a wide, open smile as it increases likeability.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackMap.smile.gray',
      defaultMessage: 'Feature cannot be detected. An open smile increases likeability and is a feature in almost all good profile pictures.',
    }),
  },
})

export const feedbackContentProfilePicture = (intl) => ({
  empty: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContentProfilePicture.emptyTitle',
      defaultMessage: 'You have not uploaded your profile picture!',
    }),
    body: (
      <FormattedMessage
        id="aspire.detailedFeedbackText.feedbackContentProfilePicture.emptyBody"
        defaultMessage="Upload your profile picture in the edit mode to get instant feedback."
      />
    ),
  },
  red: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContentProfilePicture.redTitle',
      defaultMessage: 'Needs Work!',
    }),
    body: (
      <FormattedMessage
        id="aspire.detailedFeedbackText.feedbackContentProfilePicture.redBody"
        defaultMessage="Consider the feedback to improve this section."
      />
    ),
  },
  yellow: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContentProfilePicture.yellowTitle',
      defaultMessage: 'On Track!',
    }),
    body: (
      <FormattedMessage
        id="aspire.detailedFeedbackText.feedbackContentProfilePicture.yellowBody"
        defaultMessage="Consider the feedback to improve this section."
      />
    ),
  },
  green: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContentProfilePicture.greenTitle',
      defaultMessage: 'Good Job!',
    }),
    body: (
      <FormattedMessage
        id="aspire.detailedFeedbackText.feedbackContentProfilePicture.greenBody"
        defaultMessage="You have done a good job of uploading a professional profile picture."
      />
    ),
  },
})

export const divisionSubHeadlineText = (intl) => ({
  categories: {
    present: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.categories.present',
      defaultMessage: 'Relevant Categories Present',
    }),
    missing: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.categories.missing',
      defaultMessage: 'Suggested Categories for Targeted Job',
    }),
    resume: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.categories.resume',
      defaultMessage: 'Missing Categories From Resume',
    }),
    cv: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.categories.cv',
      defaultMessage: 'Missing Categories from CV',
    }),
  },
  skills: {
    present: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.skills.present',
      defaultMessage: 'Relevant Skills Present',
    }),
    missing: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.skills.missing',
      defaultMessage: 'Suggested Skills for Targeted Job ',
    }),
    resume: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.skills.resume',
      defaultMessage: 'Missing Skills from Resume',
    }),
    cv: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.skills.cv',
      defaultMessage: 'Missing Skills from CV',
    }),
  },
  visibility: {
    present: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.visibility.present',
      defaultMessage: 'SEO Keywords Present',
    }),
    missing: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.divisionSubHeadlineText.visibility.missing',
      defaultMessage: 'Suggested SEO keywords',
    }),
  },
})



export const languageContent = (intl) => ({
    title: {
    buzzwords: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.languageContent.title.buzzwords',
      defaultMessage: 'Avoided Words',
    }),
    verb_overusage: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.languageContent.title.verbOverusage',
      defaultMessage: 'Overusage',
    }),
    tense: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.languageContent.title.tense',
      defaultMessage: 'Tense',
    }),
    narrative_voice: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.languageContent.title.narrativeVoice',
      defaultMessage: 'Voice',
    }),
    spell_check: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.languageContent.title.spellCheck',
      defaultMessage: 'Spell Error',
    }),
  },
  content_section_score: {
    Headline: {
      red: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.buzzwords.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.buzzwords.text',
            defaultMessage: 'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.verbOverusage.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.verbOverusage.text',
            defaultMessage: 'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.tense.title',
            defaultMessage: 'Needs Work!',
          }),
          text: '',
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.narrativeVoice.title',
            defaultMessage: 'Needs Work!',
          }),
          text: '',
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.red.spellCheck.title',
            defaultMessage: 'Needs Work!',
          }),
          text: '',
        },
      },
      green: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.buzzwords.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.buzzwords.text',
            defaultMessage: "Good Job! You have stayed away from using any fillers, that's great!",
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.verbOverusage.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.verbOverusage.text',
            defaultMessage: 'You have not overused any verb, good job!',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.tense.title',
            defaultMessage: 'Good Job!',
          }),
          text: '',
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.narrativeVoice.title',
            defaultMessage: 'Good Job!',
          }),
          text: '',
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.green.spellCheck.title',
            defaultMessage: 'Good Job!',
          }),
          text: '',
        },
      },
      yellow: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.buzzwords.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.buzzwords.text',
            defaultMessage: 'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.verbOverusage.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.verbOverusage.text',
            defaultMessage: 'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.tense.title',
            defaultMessage: 'On Track!',
          }),
          text: '',
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.narrativeVoice.title',
            defaultMessage: 'On Track!',
          }),
          text: '',
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.headline.yellow.spellCheck.title',
            defaultMessage: 'On Track!',
          }),
          text: '',
        },
      },
    },
    Summary: {
      red: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.buzzwords.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.buzzwords.text',
            defaultMessage: 'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.verbOverusage.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.verbOverusage.text',
            defaultMessage: 'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.tense.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.tense.text',
            defaultMessage: 'You have switched tenses in your sample multiple times, making it inconsistent. Try writing the sample without switching the tense too much.',
          }),
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.narrativeVoice.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.narrativeVoice.text',
            defaultMessage: 'While writing your summary, try to avoid switching voice from first person to third person or vice versa when talking about yourself.',
          }),
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.red.spellCheck.title',
            defaultMessage: 'Needs Work!',
          }),
          text: '',
        },
      },
      green: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.buzzwords.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.buzzwords.text',
            defaultMessage: "Good Job! You have stayed away from using any fillers, that's great!",
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.verbOverusage.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.verbOverusage.text',
            defaultMessage: 'You have not overused any verb, good job!',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.tense.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.tense.text',
            defaultMessage: 'Good Job! You have avoided switching between tenses too much and maintained consistency in your sample.',
          }),
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.narrativeVoice.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.narrativeVoice.text',
            defaultMessage: 'You have done a good job of writing your summary section without switching voice from first person to third person or vice versa.',
          }),
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.green.spellCheck.title',
            defaultMessage: 'Good Job!',
          }),
          text: '',
        },
      },
      yellow: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.buzzwords.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.buzzwords.text',
            defaultMessage: 'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.verbOverusage.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.verbOverusage.text',
            defaultMessage: 'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.tense.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.tense.text',
            defaultMessage: 'You have switched tenses multiple times in your sample, making it inconsistent. Try writing the sample without switching the tense too much.',
          }),
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.narrativeVoice.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.narrativeVoice.text',
            defaultMessage: 'While writing your summary, try to avoid switching voice from first person to third person or vice versa when talking about yourself.',
          }),
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.summary.yellow.spellCheck.title',
            defaultMessage: 'On Track!',
          }),
          text: '',
        },
      },
    },


    
    Experience: {
      red: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.buzzwords.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.buzzwords.text',
            defaultMessage: 'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.verbOverusage.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.verbOverusage.text',
            defaultMessage: 'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.tense.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.tense.text',
            defaultMessage: 'You have switched tenses in your sample, making it inconsistent. Try writing the sample in single tense.',
          }),
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.narrativeVoice.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.narrativeVoice.text',
            defaultMessage: 'You have used third person voice in your sample. Try to write information about yourself in first person.',
          }),
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.red.spellCheck.title',
            defaultMessage: 'Needs Work!',
          }),
          text: '',
        },
      },
      green: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.buzzwords.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.buzzwords.text',
            defaultMessage: "Good Job! You have stayed away from using any fillers, that's great!",
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.verbOverusage.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.verbOverusage.text',
            defaultMessage: 'You have not overused any verb, good job!',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.tense.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.tense.text',
            defaultMessage: 'Good Job! You have avoided switching between tenses and maintained consistency in your sample.',
          }),
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.narrativeVoice.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.narrativeVoice.text',
            defaultMessage: 'You have done an excellent job of writing your section in first person and keeping the use of third person voice limited to only necessary parts.',
          }),
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.green.spellCheck.title',
            defaultMessage: 'Good Job!',
          }),
          text: '',
        },
      },
      yellow: {
        buzzwords: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.buzzwords.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.buzzwords.text',
            defaultMessage: 'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
        },
        verb_overusage: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.verbOverusage.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.verbOverusage.text',
            defaultMessage: 'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
        },
        tense: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.tense.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.tense.text',
            defaultMessage: 'You have switched tenses in your sample, making it inconsistent. Try writing the sample in single tense.',
          }),
        },
        narrative_voice: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.narrativeVoice.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.narrativeVoice.text',
            defaultMessage: 'You have used third person voice in your sample. Try to write information about yourself in first person.',
          }),
        },
        spell_check: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.languageContent.sectionScore.experience.yellow.spellCheck.title',
            defaultMessage: 'On Track!',
          }),
          text: '',
        },
      },
    },
  },
    
  content: {
    buzzwords: (
      <div className="content">
        <p>
          <strong>
            <FormattedMessage
              id="aspire.detailedFeedbackText.languageContent.content.buzzwords"
              defaultMessage="What are Avoided Words?"
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.languageContent.content.buzzwordsDesc"
            defaultMessage="Avoided Words include passive language, filler words, often used in a profile consuming space without much impact."
          />
        </p>
      </div>
    ),
    verb_overusage: (
      <div className="content">
        <p>
          <strong>
            <FormattedMessage
              id="aspire.detailedFeedbackText.languageContent.content.verbOverusage"
              defaultMessage="What is Overusage?"
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.languageContent.content.verbOverusageDesc"
            defaultMessage="Using same words again and again makes a particular sample sound too repetitive. Each word of a sample holds a certain weight and repeating words lends a negative impression."
          />
        </p>
      </div>
    ),
    tense: (
      <div className="content">
        <p>
          <strong>
            <FormattedMessage
              id="aspire.detailedFeedbackText.languageContent.content.tense"
              defaultMessage="What is Tense Inconsistency?"
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.languageContent.content.tenseDesc"
            defaultMessage="Tense inconsistency measures the amount of switch between tenses. You should try to stick to the same tense."
          />
        </p>
      </div>
    ),
    narrative_voice: (
      <div className="content">
        <p>
          <strong>
            <FormattedMessage
              id="aspire.detailedFeedbackText.languageContent.content.narrativeVoice"
              defaultMessage="What is Voice Feedback?"
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.languageContent.content.narrativeVoiceDesc"
            defaultMessage="It checks for the narrative voice. One must try to keep the profile in first person and avoid using third person."
          />
        </p>
      </div>
    ),
    spell_check: (
      <div className="content">
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.languageContent.content.spellCheck"
            defaultMessage="Stuff for Tab Spell"
          />
        </p>
      </div>
    ),
  },
})



export const impactContent = (intl) => ({
  content: {
    action_oriented: (
      <div className="content feedback-impact-content">
        <p>
          <strong>
            <FormattedMessage
              id="aspire.detailedFeedbackText.impactContent.content.actionOriented"
              defaultMessage="What is Action Oriented?"
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.impactContent.content.actionOrientedDesc"
            defaultMessage="Your experience need to showcase what work you did. Begin your bullets with strong action verbs that tell the viewer what actions you performed."
          />
        </p>
      </div>
    ),
    specifics: (
      <div className="content feedback-impact-content">
        <p>
          <strong>
            <FormattedMessage
              id="aspire.detailedFeedbackText.impactContent.content.specifics"
              defaultMessage="What are Specifics?"
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.impactContent.content.specificsDesc"
            defaultMessage="Specifics refer to the quantification of outcomes/ impact in your profile. These are outlined by a quantifiable outcome or size and scope of work."
          />
        </p>
      </div>
    ),
  },
  title: {
    action_oriented: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.impactContent.title.actionOriented',
      defaultMessage: 'Action Oriented',
    }),
    specifics: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.impactContent.title.specifics',
      defaultMessage: 'Specifics',
    }),
  },
  content_section_score: {
    Summary: {
      red: {
        action_oriented: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.red.actionOriented.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.red.actionOriented.text',
            defaultMessage:
              'You have not begun your bullets with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
        },
        specifics: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.red.specifics.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.red.specifics.text',
            defaultMessage:
              'Try to use specifics in the bullets to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
      },
      green: {
        action_oriented: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.green.actionOriented.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.green.actionOriented.text',
            defaultMessage:
              'Good Job! You have begun your bullets with strong action verbs signalling actions performed by you.',
          }),
        },
        specifics: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.green.specifics.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.green.specifics.text',
            defaultMessage:
              'You have done a good job of quantifying your impact in the bullets.',
          }),
        },
      },
      yellow: {
        action_oriented: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.yellow.actionOriented.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.yellow.actionOriented.text',
            defaultMessage:
              'You have not begun your bullets with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
        },
        specifics: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.yellow.specifics.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.summary.yellow.specifics.text',
            defaultMessage:
              'Try to use specifics in the bullets to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
      },
    },
    Experience: {
      red: {
        action_oriented: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.red.actionOriented.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.red.actionOriented.text',
            defaultMessage:
              'You have not begun your sentences with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
        },
        specifics: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.red.specifics.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.red.specifics.text',
            defaultMessage:
              'Try to use specifics to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
      },
      green: {
        action_oriented: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.green.actionOriented.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.green.actionOriented.text',
            defaultMessage:
              'Good Job! You have begun your sentences with strong action verbs signalling actions performed by you.',
          }),
        },
        specifics: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.green.specifics.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.green.specifics.text',
            defaultMessage:
              'You have done a good job of quantifying your impact in this experience.',
          }),
        },
      },
      yellow: {
        action_oriented: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.yellow.actionOriented.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.yellow.actionOriented.text',
            defaultMessage:
              'You have not begun your sentences with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
        },
        specifics: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.yellow.specifics.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.impactContent.sectionScore.experience.yellow.specifics.text',
            defaultMessage:
              'Try to use specifics to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
      },
    },
  },
})

export const presentationContent = (intl, isUKEnable = false) => ({
  title: {
    bullet_length: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.presentationContent.title.bulletLength',
      defaultMessage: 'Length',
    }),
    bullets_count: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.presentationContent.title.bulletCount',
      defaultMessage: 'Structure',
    }),
    grammar: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.presentationContent.title.grammar',
      defaultMessage: 'Grammar',
    }),
  },
  content_section_score: {
    Summary: {
      red: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.red.bulletLength.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.red.bulletLength.text',
            defaultMessage:
              'Length needs tuning. Edit your summary and write in about 1600-2200 characters to stay within the sweet spot for readability.'
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.red.bullets_count.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.red.bullets_count.text',
            defaultMessage:
              'Structure needs work. Replace dense text with three to four short paragraphs, two to three sentences each, {isUKEnable, select, true {centred} other {centered}} on outcomes.'
          }, { isUKEnable: isUKEnable ? 'true' : 'false' }),
        },
        grammar: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.red.grammar.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.red.grammar.text',
            defaultMessage:
              'Grammar needs attention. Fix agreement and tense issues, plus spelling errors, to improve clarity and credibility.',
          }),
        },
      },
      green: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.green.bulletLength.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.green.bulletLength.text',
            defaultMessage:
              'Spot on length! easy to scan and impactful. Keep this range to {isUKEnable, select, true {maximise} other {maximize}} recruiter attention and engagement.',
          }, { isUKEnable: isUKEnable ? 'true' : 'false' }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.green.bullets_count.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.green.bullets_count.text',
            defaultMessage:
              'Great structure. Short paragraphs flow well, weaving story, highlighting impact, metrics, and specialties.',
          }),
        },
        grammar: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.green.grammar.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.green.grammar.text',
            defaultMessage:
              'Reads smoothly. Tense, agreement, and capitalization are consistent. First-person voice feels natural and confident throughout the section.',
          }),
        },
      },
      yellow: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.yellow.bulletLength.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.yellow.bulletLength.text',
            defaultMessage:
              'Almost there on length. Write in about 1600-2200 characters to stay within the sweet spot for readability.',
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.yellow.bullets_count.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.yellow.bullets_count.text',
            defaultMessage:
              'Close on structure. Aim for three to four short paragraphs. Split long sentences and strengthen topic sentences for clarity.',
          }),
        },
        grammar: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.yellow.grammar.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.summary.yellow.grammar.text',
            defaultMessage:
              'Some slips present. Tidy punctuation and tense shifts, and keep first-person voice consistent across sentences.',
          }),
        },
      },
    },
    Experience: {
      red: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.red.bulletLength.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.red.bulletLength.text',
            defaultMessage:
              'Length needs revision. Use 800-1500 characters to stay within the sweet spot for readability. Focus on actions, scope, and quantified results.',
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.red.bullets_count.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.red.bullets_count.text',
            defaultMessage:
              'Structure needs overhaul. Convert paragraphs into three to six concise bullets and lead each line with outcome-focused action verbs.',
          }),
        },
        grammar: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.red.grammar.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.red.grammar.text',
            defaultMessage:
              'Grammar needs improvement. Tense mix, agreement errors, and spelling issues make bullets hard to trust.',
          }),
        },
      },
      green: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.green.bulletLength.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.green.bulletLength.text',
            defaultMessage:
              'Great length. Enough context and measurable outcomes without fluff. Each bullet adds clear value and evidence.',
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.green.bullets_count.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.green.bullets_count.text',
            defaultMessage:
              'Clear structure. Three to six crisp bullets with strong verbs first and visible results at the end.'
          }),
        },
        grammar: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.green.grammar.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.green.grammar.text',
            defaultMessage:
              'Grammar looks solid. Parallel bullet style, consistent tense, and neat punctuation throughout this role description overall.'
          }),
        },
      },
      yellow: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.yellow.bulletLength.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.yellow.bulletLength.text',
            defaultMessage:
              'Almost there on length. Keep within 800-1500 characters, so results and scope stand out quickly.'
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.yellow.bullets_count.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.yellow.bullets_count.text',
            defaultMessage:
              'Close on structure. Split dense text into three to six crisp bullets, and surface outcomes for better scanning.'
          }),
        },
        grammar: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.yellow.grammar.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.experience.yellow.grammar.text',
            defaultMessage:
              'Some issues appear. Align verb forms, fix commas, and remove typos to improve clarity and professionalism.'
          }),
        },
      },
    },
    Headline: {
      red: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.headline.red.bulletLength.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.headline.red.bulletLength.text',
            defaultMessage:
              'Too short! Needs tuning. Use 140-220 characters to stay within the sweet spot for readability.'
          }),
        },
      },
      green: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.headline.green.bulletLength.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.headline.green.bulletLength.text',
            defaultMessage:
              'Spot on length. Clear role and value with the right keywords.'
          }),
        },
      },
      yellow: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.headline.yellow.bulletLength.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.headline.yellow.bulletLength.text',
            defaultMessage:
              'Almost there. Add a little detail to sharpen focus. Use 140-220 characters to stay within the sweet spot for readability.'
          }),
        },
      },
    },
    Education: {
      red: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.red.bulletLength.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.red.bulletLength.text',
            defaultMessage:
              'Length needs refinement. Stay within 300-600 characters for optimal readability. Keep essentials only and remove extraneous detail here.'
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.red.bullets_count.title',
            defaultMessage: 'Needs Work!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.red.bullets_count.text',
            defaultMessage:
              'Structure needs attention. Avoid dense text. Present key items in one to three short bullets with tight phrasing.',
          }),
        },
      },
      green: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.green.bulletLength.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.green.bulletLength.text',
            defaultMessage:
              'Good length. Degree, focus, {isUKEnable, select, true {honours} other {honors}}, and one highlight are clear without unnecessary detail or repetition overall.',
          }, { isUKEnable: isUKEnable ? 'true' : 'false' }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.green.bullets_count.title',
            defaultMessage: 'Good Job!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.green.bullets_count.text',
            defaultMessage:
              'Structure works well. Short lines or a few bullets highlight {isUKEnable, select, true {honours} other {honors}}, projects, and leadership cleanly throughout.',
          }, { isUKEnable: isUKEnable ? 'true' : 'false' }),
        },
      },
      yellow: {
        bullet_length: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.yellow.bulletLength.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.yellow.bulletLength.text',
            defaultMessage:
              'Almost there. Use 300-600 characters, so essentials remain scannable and relevant to your target roles.',
          }),
        },
        bullets_count: {
          title: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.yellow.bullets_count.title',
            defaultMessage: 'On Track!',
          }),
          text: intl.formatMessage({
            id: 'aspire.detailedFeedbackText.presentationContent.sectionScore.education.yellow.bullets_count.text',
            defaultMessage:
              'Close on structure. Simplify phrasing or convert a paragraph into brief one to three bullets for quick scanning overall.',
          }),
        },
      },
    },
  },
})


export const feedbackContent = (intl) => ({
  empty: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContent.empty.titleText',
      defaultMessage: 'You have not written this section!',
    }),
    title: (
      <div className="message text-red">
        <FormattedMessage
          id="aspire.detailedFeedbackText.feedbackContent.empty.title"
          defaultMessage="You have not written this section!"
        />
      </div>
    ),
    body: {
      categories: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.empty.body.categories"
            defaultMessage="Unable to find any mentioned categories as the seciton is empty."
          />
        </p>
      ),
      language: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.empty.body.language"
            defaultMessage="The language parameter is evaluated along the following aspects. Write atleast 50+ words for language feedback."
          />
        </p>
      ),
      impact: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.empty.body.impact"
            defaultMessage="The impact parameter is evaluated along the following aspects."
          />
        </p>
      ),
      skills: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.empty.body.skills"
            defaultMessage="There are no skills detected as the section is empty."
          />
        </p>
      ),
      seo: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.empty.body.seo"
            defaultMessage="There are no relevant SEO keywords detected as the section is empty."
          />
        </p>
      ),
      section_score: {
        Headline: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.empty.body.sectionScore.headline"
              defaultMessage="Start writing in the edit mode."
            />
          </p>
        ),
        Summary: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.empty.body.sectionScore.summary"
              defaultMessage="Start writing in the edit mode."
            />
          </p>
        ),
        Experience: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.empty.body.sectionScore.experience"
              defaultMessage="Start writing in the edit mode."
            />
          </p>
        ),
        Education: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.empty.body.sectionScore.education"
              defaultMessage="Start writing in the edit mode."
            />
          </p>
        ),
      },
    },
  },
  red: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContent.red.titleText',
      defaultMessage: 'Needs Work!',
    }),
    title: (
      <div className="message text-red">
        <FormattedMessage
          id="aspire.detailedFeedbackText.feedbackContent.red.title"
          defaultMessage="Needs Work!"
        />
      </div>
    ),
    body: {
      categories: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.red.body.categories"
            defaultMessage="Please consider adding more relevant categories in this section. See edit mode for category suggestions."
          />
        </p>
      ),
      language: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.red.body.language"
            defaultMessage="Follow the feedback to improve your language in this section."
          />
        </p>
      ),
      impact: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.red.body.impact"
            defaultMessage="Follow the feedback to make your section more impactful."
          />
        </p>
      ),
      skills: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.red.body.skills"
            defaultMessage="You should try to include more skills relevant to target job function(s) from your profile."
          />
        </p>
      ),
      seo: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.red.body.seo"
            defaultMessage="Include more SEO keywords by incorporating additional information categories. See edit mode for suggestions."
          />
        </p>
      ),
      section_score: {
        Headline: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.red.body.sectionScore.headline"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
        Summary: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.red.body.sectionScore.summary"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
        Experience: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.red.body.sectionScore.experience"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
        Education: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.red.body.sectionScore.education"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
      },
    },
  },
  yellow: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContent.yellow.titleText',
      defaultMessage: 'On Track!',
    }),
    title: (
      <div className="message text-yellow">
        <FormattedMessage
          id="aspire.detailedFeedbackText.feedbackContent.yellow.title"
          defaultMessage="On Track!"
        />
      </div>
    ),
    body: {
      categories: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.yellow.body.categories"
            defaultMessage="Please consider adding more relevant categories in this section. See edit mode for category suggestions."
          />
        </p>
      ),
      language: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.yellow.body.language"
            defaultMessage="Follow the feedback to improve your language in this section."
          />
        </p>
      ),
      impact: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.yellow.body.impact"
            defaultMessage="Follow the feedback to make your section more impactful."
          />
        </p>
      ),
      skills: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.yellow.body.skills"
            defaultMessage="You should try to include more skills relevant to target job function(s) from your profile."
          />
        </p>
      ),
      seo: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.yellow.body.seo"
            defaultMessage="Include more SEO keywords by incorporating additional information categories. See edit mode for suggestions."
          />
        </p>
      ),
      section_score: {
        Headline: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.yellow.body.sectionScore.headline"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
        Summary: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.yellow.body.sectionScore.summary"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
        Experience: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.yellow.body.sectionScore.experience"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
        Education: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.yellow.body.sectionScore.education"
              defaultMessage="Consider the feedback to improve this section."
            />
          </p>
        ),
      },
    },
  },
  green: {
    title_text: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.feedbackContent.green.titleText',
      defaultMessage: 'Good Job!',
    }),
    title: (
      <div className="message text-green">
        <FormattedMessage
          id="aspire.detailedFeedbackText.feedbackContent.green.title"
          defaultMessage="Good Job!"
        />
      </div>
    ),
    body: {
      categories: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.green.body.categories"
            defaultMessage="You have added sufficient number of relevant categories."
          />
        </p>
      ),
      language: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.green.body.language"
            defaultMessage="Follow the feedback to further improve your language in this section."
          />
        </p>
      ),
      impact: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.green.body.impact"
            defaultMessage="Your section is impactful. Great work!"
          />
        </p>
      ),
      skills: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.green.body.skills"
            defaultMessage="You have included top skills relevant to target job function(s) from your profile."
          />
        </p>
      ),
      seo: (
        <p>
          <FormattedMessage
            id="aspire.detailedFeedbackText.feedbackContent.green.body.seo"
            defaultMessage="You have done a good job of including SEO keywords here."
          />
        </p>
      ),
      section_score: {
        Headline: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.green.body.sectionScore.headline"
              defaultMessage="You have done a good job with this section."
            />
          </p>
        ),
        Summary: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.green.body.sectionScore.summary"
              defaultMessage="You have done a good job with this section."
            />
          </p>
        ),
        Experience: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.green.body.sectionScore.experience"
              defaultMessage="You have done a good job with this experience."
            />
          </p>
        ),
        Education: (
          <p>
            <FormattedMessage
              id="aspire.detailedFeedbackText.feedbackContent.green.body.sectionScore.education"
              defaultMessage="You have done a good job with this section."
            />
          </p>
        ),
      },
    },
  },
})


export const sectionActionableContent = (intl, isUKEnable, isResumeCalledCv = false) => ({
  green: {
    heading: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.sectionActionableContent.green.heading',
      defaultMessage: 'Great Job!',
    }),
    subheading: intl.formatMessage({
      id: 'aspire.detailedFeedbackText.sectionActionableContent.green.subheading',
      defaultMessage: 'See feedback and samples to further improve',
    }),
  },

  profile_picture: {
    missing: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.missing.heading',
        defaultMessage: 'Missing professional picture !',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.missing.subheading',
        defaultMessage: 'Upload profile picture to maximise views',
      }),
    },

    two_cases_fail: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.twoCasesFail.heading',
        defaultMessage: 'Edit your profile picture to fit LinkedIn',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.twoCasesFail.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our dynamic feedback to edit your picture',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },

    face_to_frame: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.faceToFrame.heading',
        defaultMessage: 'Improve face to frame ratio',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.faceToFrame.subheading',
        defaultMessage: 'Maintain 50% face to frame ratio to enrich your profile picture',
      }),
    },
    face_to_body: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.faceToBody.heading',
        defaultMessage: 'Improve face to body ratio',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.faceToBody.subheading',
        defaultMessage: 'Maintain 60% face to body ratio to enrich your profile picture',
      }),
    },
    background_illumination: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.backgroundIllumination.heading',
        defaultMessage: 'Improve profile picture illumination',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.backgroundIllumination.subheading',
        defaultMessage: 'Eliminate background interference to reduce picture noise',
      }),
    },
    foreground_illumination: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.foregroundIllumination.heading',
        defaultMessage: 'Improve profile picture illumination',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.profilePicture.foregroundIllumination.subheading',
        defaultMessage: 'See our suggestions to improve picture contrast ',
      }),
    },
  },

  headline: {
    missing: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.missing.heading',
        defaultMessage: 'Headline is too short!',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.missing.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our suggestions on exhibiting your unique value proposition',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },
    base_case: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.baseCase.heading',
        defaultMessage: 'Enhance headline content !',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.baseCase.subheading',
        defaultMessage: 'Integrate recommendations on content, skills and visibility',
      }),
    },

    word_count: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.wordCount.heading',
        defaultMessage: 'Headline is too short',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.wordCount.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our suggestions on exhibiting your unique value proposition',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },

    skills: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.skills.heading',
        defaultMessage: 'Add more skills',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.skills.subheading',
        defaultMessage: 'Improve headline by including job profile and professional skills',
      }),
    },

    content: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.content.heading',
        defaultMessage: 'Include more categories',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.content.subheading',
        defaultMessage: 'Incorporate name of academic institution , comapny name , job function etc.',
      }),
    },

    visibility: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.visibility.heading',
        defaultMessage: 'Make headline more visible ',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.headline.visibility.subheading',
        defaultMessage: 'Improve headline by including job profile and professional skills',
      }),
    },
  },

  summary: {
    missing: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.missing.heading',
        defaultMessage: 'Missing about section !',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.missing.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our suggestions on exhibiting your unique value proposition',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },

    word_count: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.wordCount.heading',
        defaultMessage: 'About is too short',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.wordCount.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our suggestions on exhibiting your unique value proposition',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },

    base_case: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.baseCase.heading',
        defaultMessage: 'Add content to improve about !',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.baseCase.subheading',
        defaultMessage: 'Revamp your content to showcase skills and enhance visibility',
      }),
    },

    skills: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.skills.heading',
        defaultMessage: 'Add more skills',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.skills.subheading',
        defaultMessage: 'Include skills to substantiate job experience and academic achievements',
      }),
    },

    content: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.content.heading',
        defaultMessage: 'Improve on content ',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.content.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our language, category and impact feedback to improve content',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },

    visibility: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.visibility.heading',
        defaultMessage: 'Add SEO keywords',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.summary.visibility.subheading',
        defaultMessage: 'Enhance your visibility by adding skills and achievements keywords',
      }),
    },
  },

  education: {
    missing: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.missing.heading',
        defaultMessage: 'Missing education information !',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.missing.subheading',
        defaultMessage: 'See our sample suggestions to get started',
      }),
    },

    base_case: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.baseCase.heading',
        defaultMessage: 'Add content in education!',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.baseCase.subheading',
        defaultMessage: 'Incorporate academic accolades and involvement in intellectual clubs',
      }),
    },

    content: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.content.heading',
        defaultMessage: 'Include categories',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.content.subheading',
        defaultMessage: 'Communicate subject specialisation, academic degree, clubs etc.',
      }),
    },

    visibility: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.visibility.heading',
        defaultMessage: 'Include SEO keywords',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.education.visibility.subheading',
        defaultMessage: 'Mention keywords to demonstrate clubs, achievements , gpa etc.',
      }),
    },
  },

  experience: {
    missing: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.missing.heading',
        defaultMessage: 'Missing experience information !',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.missing.subheading',
        defaultMessage: 'See our sample suggestions to get started',
      }),
    },

    base_case_1: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.baseCase1.heading',
        defaultMessage: '8 of 8 experiences need attention',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.baseCase1.subheading',
        defaultMessage: 'See sample recommendations to progress to the green zone',
      }),
    },

    base_case: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.baseCase.heading',
        defaultMessage: 'Improve content in your experiences',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.baseCase.subheading',
        defaultMessage: 'Integrate recommendations on content, skills and visibility',
      }),
    },

    word_count: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.wordCount.heading',
        defaultMessage: 'Description at Present experience missing !',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.wordCount.subheading',
        defaultMessage: 'See our sample recommendations to articulate specific experiences',
      }),
    },
    skills: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.skills.heading',
        defaultMessage: 'Add more skills',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.skills.subheading',
        defaultMessage: 'Showcase your skills by describing your job profile and career trajectory',
      }),
    },
    content: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.content.heading',
        defaultMessage: 'Overall low content score',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.content.subheading',
          defaultMessage: 'Utili{zeOrSe, select, se {se} ze {ze} other {se}} our language, category and impact feedback to improve content',
        },
        { zeOrSe: isUKEnable ? 'se' : 'ze' }
      ),
    },
    visibility: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.visibility.heading',
        defaultMessage: 'Overall low visibility score',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.experience.visibility.subheading',
        defaultMessage: 'See our sample recommendations to articulate specific experiences',
      }),
    },
  },
  personal_information: {
    url: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.url.heading',
        defaultMessage: 'Improve your profile URL',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.url.subheading',
        defaultMessage: 'Follow our suggestion to simplify your LinkedIn URL',
      }),
    },
    name_resume: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.nameResume.heading',
        defaultMessage: 'Get feedback on profile name!',
      }),
      subheading: intl.formatMessage(
        {
          id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.nameResume.subheading',
          defaultMessage: "Looks like your name doesn't match the name provided in your {resumeType, select, cv {CV} other {resume}}",
        },
        { resumeType: isResumeCalledCv ? 'cv' : 'resume' }
      ),
    },
    name_cv: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.nameCv.heading',
        defaultMessage: 'Get feedback on profile name!',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.nameCv.subheading',
        defaultMessage: "Looks like your name doesn't match the name provided in your CV",
      }),
    },
    name: {
      heading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.name.heading',
        defaultMessage: 'Get feedback on profile name!',
      }),
      subheading: intl.formatMessage({
        id: 'aspire.detailedFeedbackText.sectionActionableContent.personalInformation.name.subheading',
        defaultMessage: 'Mention both your First and Last name',
      }),
    },
  },
})

export const emptySectionMessage = (intl, isUKEnable = false) => ({
  'Personal Information': null,
  'Profile Picture': [
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.profilePicture.0',
      defaultMessage: 'Add your profile picture and get noticed by recruiters at the very first glance',
    }),
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.profilePicture.1',
      defaultMessage: 'Increase the visibility of your LinkedIn profile and grow your LinkedIn network',
    }),
  ],
  Headline: [
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.headline.0',
      defaultMessage: 'A well-optimized headline is crucial to grab recruiters attention and can significantly impact your search engine rankings',
    }),
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.headline.1',
      defaultMessage: 'Add relevant keywords in your headline and align it with the core message of your LinkedIn Profile',
    }),
  ],
  Summary: [
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.summary.0',
      defaultMessage: 'Define yourself in your own words in the About section and strengthen your first impression on the recruiters',
    }),
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.summary.1',
      defaultMessage: 'Put your career choices in context, highlight your biggest achievements, and show off your personality',
    }),
  ],
  Experience: [
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.experience.0',
      defaultMessage: 'Give a glimpse of your professional journey to your LinkedIn community',
    }),
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.experience.1',
      defaultMessage: 'Share your previous and current roles, positions of responsibilities, and details of your past work experience',
    }),
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.experience.2',
      defaultMessage: 'List your internships, contract positions, freelancing experience, and part-time jobs',
    }),
  ],
  Education: [
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.education.0',
      defaultMessage: "Include the school you're attending as well as any majors or degrees that you're earning or have already earned",
    }),
    intl.formatMessage({
      id: 'aspire.detailedFeedbackText.emptySectionMessage.education.1',
      defaultMessage: "Add clubs, extracurricular activities you've taken part in, {isUKEnable, select, true {honours} other {honors}} you've received, or any other significant things you've accomplished at school",
    }, { isUKEnable: isUKEnable ? 'true' : 'false' }),
  ],
})
